import { createFileRoute, Link } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { MessageSquare } from "lucide-react";

import { PageHero, Section } from "@/components/site/section";
import { forumThreadsQuery } from "@/lib/site-queries";

export const Route = createFileRoute("/forum")({
  head: () => ({
    meta: [
      { title: "Forums | Argentinian.Soccer" },
      { name: "description", content: "The Argentinian.Soccer community: argue the line-up, debate the GOAT, and call the World Cup." },
      { property: "og:title", content: "Forums | Argentinian.Soccer" },
      { property: "og:url", content: "/forum" },
    ],
    links: [{ rel: "canonical", href: "/forum" }],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(forumThreadsQuery()),
  component: ForumPage,
});

function ForumPage() {
  const { data } = useSuspenseQuery(forumThreadsQuery());

  return (
    <>
      <PageHero eyebrow="Community" title="Argentina" description="Hot threads in the Argentinian.Soccer community." />
      <Section>
        <div className="mb-6 flex items-center justify-between">
          <p className="text-sm text-muted-foreground">{data.length} active threads</p>
          <Link to="/forum/polls" className="text-sm font-semibold text-primary">View polls →</Link>
        </div>
        <div className="space-y-3">
          {data.map((t) => (
            <div key={t.id} className="flex items-start gap-4 rounded-lg border border-border bg-card p-5">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <MessageSquare className="h-5 w-5" />
              </div>
              <div className="flex-1">
                <h2 className="font-display text-lg font-bold text-navy">{t.title}</h2>
                {t.body && <p className="mt-1 text-sm text-muted-foreground">{t.body}</p>}
                <p className="mt-2 text-xs text-muted-foreground">
                  by {t.author_name ?? "Anonymous"} · {t.reply_count} replies
                </p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-6 text-xs text-muted-foreground">
          Want to post? <Link to="/log-in" className="font-semibold text-primary">Sign in</Link> to join the conversation.
        </p>
      </Section>
    </>
  );
}
